"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GramPerPoundLb = exports.GrainPerPoundLb = exports.PoundLbPerPoundLb = exports.GramPerKilogram = exports.KilogramPerKilogram = void 0;
var uom_1 = require("uom");
var UnitDivide = require("../unit-divide");
var mass_1 = require("./mass");
// Humidity
exports.KilogramPerKilogram = UnitDivide.massByMass("KilogramPerKilogram", uom_1.BaseUnits.Kilogram, uom_1.BaseUnits.Kilogram);
exports.GramPerKilogram = UnitDivide.massByMass("GramPerKilogram", mass_1.Gram, uom_1.BaseUnits.Kilogram);
exports.PoundLbPerPoundLb = UnitDivide.massByMass("PoundLbPerPoundLb", mass_1.PoundLb, mass_1.PoundLb);
exports.GrainPerPoundLb = UnitDivide.massByMass("GrainPerPoundLb", mass_1.Grain, mass_1.PoundLb);
exports.GramPerPoundLb = UnitDivide.massByMass("GramPerPoundLb", mass_1.Gram, mass_1.PoundLb);
//# sourceMappingURL=humidity-ratio.js.map